import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { useCallback, useMemo, useState } from "react";

import { useProductComparisonContext } from "../productComparison.context";
import { getDistinctSections, getSections } from "../productComparison.helpers";
import { FeaturesComponent } from "./features.component";

export type FeaturesProps = {
    products: Array<Product<ProductFieldSet.ProductTile>>;
    width: number;
};

const Features = ({ products, width }: FeaturesProps) => {
    const { differenceOnly } = useProductComparisonContext();

    const [closedSections, setClosedSections] = useState<
        Record<string, boolean>
    >({});

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    const toggleSection = useCallback(
        (sectionName: string) => {
            setClosedSections((state) => ({
                ...state,
                [sectionName]: !closedSections?.[sectionName]
            }));
        },
        [closedSections, setClosedSections]
    );

    const sections = useMemo(() => {
        if (!isDefined(products)) return {};

        return differenceOnly
            ? getDistinctSections(products)
            : getSections(products);
    }, [products, differenceOnly]);

    return (
        <FeaturesComponent
            sections={sections}
            closedSections={closedSections}
            products={products}
            width={width}
            toggleSection={toggleSection}
        />
    );
};

export { Features };
